<template>
    <nav class="navbar navigation navbar-expand-lg home" :class="{'navigation-fixed': navigationFixed}" v-click-outside="hideSubmenu">
        <div class="container">

            <!-- Brand -->
            <router-link :to="{ path: getHome(translatable, locality) }" class="navbar-brand">
                <img src="/app/images/logo/Verozza_Logo_White.svg" :alt="getSnippets('Company')" v-if="!navigationFixed">
                <img src="/app/images/logo/Verozza_Logo_Color.svg" :alt="getSnippets('Company')" v-if="navigationFixed">
            </router-link>

            <!-- Toggler -->
            <div class="toggler">
                <button class="navbar-toggler" v-bind:class="[toggle ? 'shown' : '']" type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation" @click="toggleNavigation($event)">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>

            <!-- Navigation Content -->
            <div class="collapse navbar-collapse" id="navbarContent">
                <div class="navbar-content">
                    <ul class="navbar-nav">
                        <li class="nav-item" :class="{ 'default':  item.category.title !== 'Products'}" v-for="item in main" :key="item.page.id" >
                            <router-link class="nav-link" :to="{ path: item.slug }" v-if="item.sequences.data.length === 0">
                                {{ getBlockTranslation(item.page, 'title') }}
                            </router-link>
                            <a href="#" class="nav-link" @click="showSubmenu($event, 'submenu' + item.page.id)" v-if="item.sequences.data.length > 0">
                                {{ getBlockTranslation(item.page, 'title') }}
                                <i class="fas fa-angle-down"></i>
                            </a>
                            <div class="submenu" v-if="item.sequences.data.length && item.category.title === 'Products'" :id="'#submenu' + item.page.id" :ref="'submenu' + item.page.id">
                                <div class="container">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-6" v-for="subItem in item.sequences.data" :key="subItem.page.id">
                                            <div class="sub-item-wrapper">
                                                <div class="sub-item-photo" v-if="getSpecificBlocks('Navigation Image', subItem.blocks)[0]">
                                                    <Photo :id="getContent(getSpecificBlocks('Navigation Image', subItem.blocks)[0], 'photo_id')" :block="getSpecificBlocks('Navigation Image', subItem.blocks)[0]" :currency="currency" :locality="locality" :snippets="snippets" :translatable="translatable"></Photo>
                                                </div>
                                                <div class="sub-item">
                                                    <router-link class="nav-link" :to="{ path: subItem.slug }">{{ getBlockTranslation(subItem.page, 'title') }}</router-link>

                                                    <!-- Sub Item Menu -->
                                                    <ul class="sub-item-menu">
                                                        <li v-for="subItemMenuItem in subItem.sequences.data" :key="subItemMenuItem.page.id">
                                                            <router-link class="nav-link" :to="{ path: subItemMenuItem.slug }">{{ getBlockTranslation(subItemMenuItem.page, 'title') }}</router-link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="show-all">
                                                <router-link class="nav-link" :to="{ path: item.slug }">
                                                    {{ getSnippets('Show All') }}
                                                    <img src="/app/images/objects/icons/icon-arrow-long-right-white.svg" :alt="getSnippets('Company')">
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="submenu" v-if="item.sequences.data.length && item.category.title !== 'Products'" :id="'#submenu' + item.page.id" :ref="'submenu' + item.page.id">
                                <ul class="sub-item-menu">
                                    <li v-for="subItem in item.sequences.data" :key="subItem.page.id">
                                        <router-link class="nav-link" :to="{ path: subItem.slug }">{{ getBlockTranslation(subItem.page, 'title') }}</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Additional -->
            <ul class="additional">
                <li>
                    <a href="#" class="nav-link" @click="search">
                        <img src="/app/images/objects/icons/icon-search-yellow.svg" :alt="getSnippets('Company')" v-if="!navigationFixed">
                        <img src="/app/images/objects/icons/icon-search-black.svg" :alt="getSnippets('Company')" v-if="navigationFixed">
                    </a>
                </li>
            </ul>

            <!-- Search Wrapper -->
            <div class="search-wrapper" :class="{ 'active' : toggleSearch }">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-8 col-md-12">
                            <form class="form form-search" @submit.prevent="submitForm()">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control" v-model="searchQuery" :placeholder="getSnippets('Find it fast...')">
                                    <div class="input-group-append">
                                        <button class="btn btn-color-1" type="submit">{{ getSnippets('Search') }}</button>
                                    </div>
                                </div>
                            </form>
                            <ul class="results" v-if="searchResults.length">
                                <li v-for="item in searchResults">
                                    <router-link :to="{ path: item.slug }">{{ getBlockTranslation(item.page, 'title') }}</router-link>
                                </li>
                            </ul>
                            <div class="cancel">
                                <a href="#" @click="search"><i class="fas fa-times fa-fw"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </nav>
</template>

<script>
    /* Mixins */
    import { Default } from '../../../mixins/Default'

    /* Directives */
    import ClickOutside from 'vue-click-outside'

    /* Components */
    import Photo from '../../../components/App/Partials/Photo'

    /* Logic */
    export default {
        name: "Navigation",
        mixins: [Default],
        props: [
            'currency',
            'locality',
            'navigation',
            'snippets',
            'slugs',
            'translatable',
        ],
        components: {
            'Photo': Photo
        },
        data: function () {
            return {
                main: '',
                footer: '',
                toggle: false,
                toggleSearch: false,
                searchQuery: '',
                searchResults: [],
                loading: false,
                status: '',
                navigationFixed: false,
                message: ''
            }
        },
        methods: {
            fetchItems: function () {
                this.main = this.navigation.main
                this.footer = this.navigation.footer
            },
            search: function (event) {
                this.toggleSearch === true ? this.toggleSearch = false : this.toggleSearch = true
                event.preventDefault()
            },
            toggleNavigation: function (event) {
                this.toggle === true ? this.toggle = false : this.toggle = true
                event.preventDefault()
            },
            submitForm: function () {
                if (this.searchQuery.length >= 3) {
                    this.setLoading(true)
                    this.Axios.post('/api/v1/search', {
                        searchQuery: this.searchQuery,
                        translatable: this.translatable,
                        locality: this.locality,
                    }).then(response => {
                        this.searchResults = response.data.content.data
                        this.status = response.data.content.status
                        this.message = response.data.content.message
                    }).catch(() => {
                        this.status = 'danger'
                        this.message = this.getSnippets('Error')
                    }).finally(() => {
                        this.setLoading(false)
                        this.status !== 'success' ? this.flash(this.message, 'alert alert-' + this.status) : null
                    })
                } else {
                    this.searchResults = []
                }
            },
            showSubmenu: function (event, data) {
                event.preventDefault()
                let element = this.$refs[data]
                if (element[0].classList.contains('show')) {
                    element[0].classList.remove('show')
                } else {
                    element[0].classList.add('show')
                }
                Object.keys(this.$refs).forEach(el => {
                    if (this.$refs[el][0].id !== '#' + data) {
                        this.$refs[el][0].classList.remove('show')
                    }
                })
            },
            hideSubmenu: function () {
                Object.keys(this.$refs).forEach(el => {
                    this.$refs[el][0].classList.remove('show')
                })
            },
            handleScroll: function () {
                window.scrollY > 0 ? this.navigationFixed = true : this.navigationFixed = false;
            }
        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        directives: {
            ClickOutside
        },
        watch: {
            locality: function () {
                this.initialize()
                this.fetchItems()
            }
        }
    }
</script>
